@if (technicalData?.technique) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Tecniche</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Materia e tecniche</dt>
        <dd>{{ technicalData.technique }}</dd>
      </div>
    </dl>
  </section>
}

@for (item of technicalData?.measures; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Misure {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.unit?.definition) {
        <div>
          <dt>Unità di misura</dt>
          <dd>{{ item.unit.definition }}</dd>
        </div>
      }
      @if (item?.height || item?.width || item?.depth || item?.diameter || item?.thickness || item?.weight) {
        <div class="sheet-facts-inline">
          @if (item?.height) {
            <div>
              <dt>Altezza</dt>
              <dd>{{ item.height }}</dd>
            </div>
          }
          @if (item?.width) {
            <div>
              <dt>Larghezza</dt>
              <dd>{{ item.width }}</dd>
            </div>
          }
          @if (item?.depth) {
            <div>
              <dt>Profondità</dt>
              <dd>{{ item.depth }}</dd>
            </div>
          }
          @if (item?.diameter) {
            <div>
              <dt>Diametro</dt>
              <dd>{{ item.diameter }}</dd>
            </div>
          }
          @if (item?.thickness) {
            <div>
              <dt>Spessore</dt>
              <dd>{{ item.thickness }}</dd>
            </div>
          }
          @if (item?.weight) {
            <div>
              <dt>Peso</dt>
              <dd>{{ item.weight }}</dd>
            </div>
          }
        </div>
      }
      @if (item?.missing?.definition) {
        <div>
          <dt>Mancanza</dt>
          <dd>{{ item.missing.definition }}</dd>
        </div>
      }
      @if (item?.validity?.definition) {
        <div>
          <dt>Validità</dt>
          <dd>{{ item.validity.definition }}</dd>
        </div>
      }
      @if (item?.others?.length > 0) {
        <div>
          <dt>Varie</dt>
          <dd>
            @for (el of item.others; track el; let j = $index) {
              {{ el.other }}@if (j + 1 < item.others.length) {; }
            }
          </dd>
        </div>
      }
    </dl>
  </section>
}
